<template>
  <AppSimpleCheckbox v-model="vModel">
    <template #label>
      Accept our <a :href="bookingTermsConditionsUrl" target="_blank" rel="noopener noreferrer">Terms & Conditions</a>
    </template>
  </AppSimpleCheckbox>
</template>

<script>
import AppConfig from '@/config';
import AppSimpleCheckbox from '@/components/AppSimpleCheckbox.vue';

export default {
  name: 'AppBookingTermsAcceptor',
  components: { AppSimpleCheckbox },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      bookingTermsConditionsUrl: AppConfig.get('marketingSite').bookingTermsConditionsUrl,
    };
  },
  computed: {
    vModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
